import PageHero from "../../components/sections/PageHero";
import IndustriesSection from "../../components/home/IndustriesSection";
import HomeCTA from "../../components/home/HomeCTA";

const IndustriesIndex = () => (
  <>
    <PageHero
      label="INDUSTRIES"
      title="Solutions shaped"
      titleAccent="by domain."
      subtitle="We tailor websites, software, CRM, ERP, AI, and automation around how your sector actually operates."
    />
    <IndustriesSection />
    <HomeCTA />
  </>
);

export default IndustriesIndex;
